var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900.16 748.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a5467137-fb88-476e-8a7b-b15efa42ecf3 {\n        fill: #f4beb2;\n      }\n\n      .bd1c892d-4ad6-49eb-8a54-832c027f8fdc, .be8122ba-2ae8-4506-8d24-ab4eec9e9c6e, .ebd4af80-3442-4a52-9c85-a60a43b07864 {\n        fill: none;\n      }\n\n      .ad4f936e-6ead-4bf8-b009-0cb5e57cb156, .b3804800-8e0c-458a-b1f7-269bb6c231d1, .bd1c892d-4ad6-49eb-8a54-832c027f8fdc, .be8122ba-2ae8-4506-8d24-ab4eec9e9c6e, .ebd4af80-3442-4a52-9c85-a60a43b07864 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .ebd4af80-3442-4a52-9c85-a60a43b07864 {\n        stroke-width: 7.5px;\n      }\n\n      .bf9a05b8-9708-487a-9c8a-361612284e30 {\n        fill: #231f20;\n      }\n\n      .b3804800-8e0c-458a-b1f7-269bb6c231d1 {\n        fill: #ee6e51;\n      }\n\n      .ad4f936e-6ead-4bf8-b009-0cb5e57cb156, .b3804800-8e0c-458a-b1f7-269bb6c231d1, .bd1c892d-4ad6-49eb-8a54-832c027f8fdc {\n        stroke-width: 6px;\n      }\n\n      .ad4f936e-6ead-4bf8-b009-0cb5e57cb156 {\n        fill: #92d4cd;\n      }\n\n      .be8122ba-2ae8-4506-8d24-ab4eec9e9c6e {\n        stroke-width: 6.24px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "communication") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aab2a02c-ef91-4117-a27b-d377cf6211b4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f38d61f2-0243-4682-8916-34dad0e1dacd",
    "data-name": "colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a5467137-fb88-476e-8a7b-b15efa42ecf3",
    d: "M401.84,132.53l-25.94,38c-4.33,6.34-1.14,14.88,5.42,14.53l55.35-10.84a6.48,6.48,0,0,1,4.66,1.61l37,42.57c5,4.32,12.73-.46,13.22-8.12l2.73-43a10.75,10.75,0,0,1,5.88-9.06l37.11-16.8c6.35-2.88,8-12.63,2.83-16.59L498.7,93.24A8.37,8.37,0,0,1,495.64,87l-2.72-46c-.44-7.54-8.19-10.2-13.17-4.53L448.54,72a8.35,8.35,0,0,1-6.24,3l-48.57-.48c-6.52-.07-11.21,8.65-8,14.82l17,32.42A10.73,10.73,0,0,1,401.84,132.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5467137-fb88-476e-8a7b-b15efa42ecf3",
    d: "M762,523l-7.59,9.16c-1.27,1.53-.66,3.81,1,3.87L770,534.58a1.71,1.71,0,0,1,1.16.52l8.5,11.86c1.17,1.23,3.29.19,3.6-1.77l1.74-11a2.77,2.77,0,0,1,1.73-2.19l10-3.43c1.7-.59,2.36-3.06,1.12-4.21l-9.89-9.14a2.15,2.15,0,0,1-.64-1.68l.41-11.9a1.88,1.88,0,0,0-3.28-1.49l-8.9,8.39a2.16,2.16,0,0,1-1.68.63l-12.5-1.3c-1.67-.17-3.09,2-2.41,3.63l3.6,8.76A2.75,2.75,0,0,1,762,523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5467137-fb88-476e-8a7b-b15efa42ecf3",
    d: "M690,557.22l7.72-9.06c1.29-1.51.7-3.8-1-3.89l-14.54,1.26A1.7,1.7,0,0,1,681,545l-8.34-12c-1.15-1.25-3.28-.23-3.62,1.72l-1.89,11a2.79,2.79,0,0,1-1.76,2.16l-10,3.3c-1.72.56-2.42,3-1.19,4.19l9.77,9.27a2.18,2.18,0,0,1,.61,1.69l-.57,11.9a1.87,1.87,0,0,0,3.26,1.53l9-8.26a2.13,2.13,0,0,1,1.69-.61l12.48,1.47c1.67.2,3.12-1.92,2.46-3.59L689.43,560A2.77,2.77,0,0,1,690,557.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ebd4af80-3442-4a52-9c85-a60a43b07864",
    d: "M740.19,211.8h0a15.49,15.49,0,0,1,8.18,10.56c-1.65,51.64,19,75.39,29.91,84.27a29.72,29.72,0,0,0,6.07,4.2l.43.23h0a29.55,29.55,0,0,0,42.5-22.48h0s5.48-27.26-3.82-50.77a29,29,0,0,1-2.1-10.55c0-3.62-.79-6.68,3.1-11.44h0a109.31,109.31,0,1,0-84.28-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    d: "M636.7,243.12c-3.9,1-6.59,5.27-6.18,10.15.45,5.33,4.45,9.34,8.93,9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 707.73,
    cy: 250.5,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(220.38 821.58) rotate(-69.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b3804800-8e0c-458a-b1f7-269bb6c231d1",
    points: "640.81 261.98 645.73 295.56 714.4 305.3 697.59 190.56 628.92 180.82 640.81 261.98"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 707.73,
    cy: 130.67,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 787.11,
    cy: 125.27,
    r: 8.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M709.66,250.78s60.39,41.11,100.62-20.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M816.76,385.65s-16.23-25.8-3.17-75.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M783.7,383.05s-16.61-24.75-3.55-74.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M748.08,221.19s-12-11.17-44.1-2.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 209.24,
    cy: 372.12,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 331.31,
    cy: 354.28,
    r: 8.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 441.46,
    cy: 411.23,
    rx: 8.15,
    ry: 9.69,
    transform: "translate(-73.25 725.97) rotate(-74.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M440.25,417.31s-19.34,89-117.86,80.92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 107.02,
    cy: 477.16,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(-336.58 271.36) rotate(-52.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M108.79,478s63.84,66.45,120,18.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ebd4af80-3442-4a52-9c85-a60a43b07864",
    d: "M317.61,512.38a39,39,0,0,1,22.64-33.8c.49-.22,1-.43,1.5-.64h0a139.6,139.6,0,0,0,91.87-109.87c12.1-75.59-39.75-147.4-115.29-159.82a139.68,139.68,0,0,0-92,259.05h0c12.62,8.69,11.1,17,8.69,21.6a105.49,105.49,0,0,0-7.19,16.55c-19.94,61.43-4.06,89.57-4.06,89.57s18.07,37.91,38.84,41.61c21.48,3.83,43.05,1.14,55.06-20a60.77,60.77,0,0,0,6.45-41.6C321,559,316.64,532.46,317.61,512.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M256.4,634.53s-25.26,47.55,6.77,110.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M297.44,634.66s-.87,60.1,66.56,93.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad4f936e-6ead-4bf8-b009-0cb5e57cb156",
    d: "M497.35,354.63l-63.84-31.05a138.28,138.28,0,0,1,.11,44.49,140,140,0,0,1-13.9,42.28l67.13-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M662.13,184.75c-44.74-39.95-112.9-31.47-144.21,11.57C485,241.6,504.55,308.16,537.2,327.41c29.38,17.32,57.5-10.67,87.14,8.48,26.16,16.91,43.29,63.93,21.59,96.4-22.42,33.56-74.84,34.38-104.87,11.56-17.56-13.34-9-39-28.53-52.43a40.44,40.44,0,0,0-21.18-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5467137-fb88-476e-8a7b-b15efa42ecf3",
    d: "M459.16,546.7l-8,31.63c-1.34,5.27,2.86,10.19,7.15,8.36L492.51,566a4.63,4.63,0,0,1,3.49-.07l35,19.36c4.35,1.67,8.37-3.4,6.83-8.62l-8.65-29.3a7.64,7.64,0,0,1,1.72-7.47l20.63-20.22c3.53-3.46,2.26-10.36-2.16-11.74L514.1,497a5.89,5.89,0,0,1-3.54-3.4l-13-30c-2.13-4.91-7.94-4.8-9.88.19L475.53,495a5.9,5.9,0,0,1-3.42,3.54L439.64,510c-4.36,1.55-5.36,8.49-1.7,11.82l19.22,17.44A7.63,7.63,0,0,1,459.16,546.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5467137-fb88-476e-8a7b-b15efa42ecf3",
    d: "M570.34,71.17,561,82.31c-1.55,1.86-.82,4.64,1.26,4.74L580,85.36a2,2,0,0,1,1.41.65l10.3,14.52c1.43,1.51,4,.25,4.41-2.14L598.31,85a3.37,3.37,0,0,1,2.13-2.66l12.18-4.13c2.08-.71,2.91-3.73,1.4-5.13L602,61.82a2.63,2.63,0,0,1-.77-2l.57-14.53a2.29,2.29,0,0,0-4-1.83L586.89,53.59a2.61,2.61,0,0,1-2,.76l-15.25-1.66c-2.05-.22-3.79,2.38-3,4.42L571,67.82A3.41,3.41,0,0,1,570.34,71.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5467137-fb88-476e-8a7b-b15efa42ecf3",
    d: "M164.71,133.64,160.86,146c-.64,2.07.92,4.11,2.66,3.47l14-7.5a1.81,1.81,0,0,1,1.39.05l13.5,8.42c1.69.75,3.39-1.18,2.89-3.29l-2.82-11.82a3,3,0,0,1,.83-2.92l8.62-7.61c1.48-1.3,1.12-4.07-.61-4.71L187.58,115a2.35,2.35,0,0,1-1.34-1.43l-4.54-12.17a2,2,0,0,0-3.93-.13l-5.48,12.15a2.33,2.33,0,0,1-1.43,1.33l-13.14,3.89c-1.76.53-2.3,3.26-.92,4.66l7.27,7.33A3,3,0,0,1,164.71,133.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5467137-fb88-476e-8a7b-b15efa42ecf3",
    d: "M94.12,344.57l25.39-5.38c4.84-1,7.48-7.52,4.49-11.06l-22.23-26.3a5.92,5.92,0,0,1-1.16-4.78L105.86,264c.84-5.29-4.12-8.31-8.43-5.15L71.09,278.12a5.91,5.91,0,0,1-4.78,1.15l-36-8.29c-4.5-1-9.08,4.28-7.78,9l7.62,27.87a7.62,7.62,0,0,1-2.29,7.3L5.63,336.14c-4,3.73-3.06,10.14,1.54,10.89l40,.94a4.61,4.61,0,0,1,3,1.82l19.12,35.12c2.78,3.75,8.89,1.62,10.39-3.61l9-31.36A7.6,7.6,0,0,1,94.12,344.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b9b80c3f-2044-4386-a8b7-f2d5f4d3c5a4",
    "data-name": "line art"
  }, /*#__PURE__*/React.createElement("path", {
    className: "be8122ba-2ae8-4506-8d24-ab4eec9e9c6e",
    d: "M401.84,132.53l-25.94,38c-4.33,6.34-1.14,14.88,5.42,14.53l55.35-10.84a6.48,6.48,0,0,1,4.66,1.61l37,42.57c5,4.32,12.73-.46,13.22-8.12l2.73-43a10.75,10.75,0,0,1,5.88-9.06l37.11-16.8c6.35-2.88,8-12.63,2.83-16.59L498.7,93.24A8.37,8.37,0,0,1,495.64,87l-2.72-46c-.44-7.54-8.19-10.2-13.17-4.53L448.54,72a8.35,8.35,0,0,1-6.24,3l-48.57-.48c-6.52-.07-11.21,8.65-8,14.82l17,32.42A10.73,10.73,0,0,1,401.84,132.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be8122ba-2ae8-4506-8d24-ab4eec9e9c6e",
    d: "M762,523l-7.59,9.16c-1.27,1.53-.66,3.81,1,3.87L770,534.58a1.71,1.71,0,0,1,1.16.52l8.5,11.86c1.17,1.23,3.29.19,3.6-1.77l1.74-11a2.77,2.77,0,0,1,1.73-2.19l10-3.43c1.7-.59,2.36-3.06,1.12-4.21l-9.89-9.14a2.15,2.15,0,0,1-.64-1.68l.41-11.9a1.88,1.88,0,0,0-3.28-1.49l-8.9,8.39a2.16,2.16,0,0,1-1.68.63l-12.5-1.3c-1.67-.17-3.09,2-2.41,3.63l3.6,8.76A2.75,2.75,0,0,1,762,523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be8122ba-2ae8-4506-8d24-ab4eec9e9c6e",
    d: "M690,557.22l7.72-9.06c1.29-1.51.7-3.8-1-3.89l-14.54,1.26A1.7,1.7,0,0,1,681,545l-8.34-12c-1.15-1.25-3.28-.23-3.62,1.72l-1.89,11a2.79,2.79,0,0,1-1.76,2.16l-10,3.3c-1.72.56-2.42,3-1.19,4.19l9.77,9.27a2.18,2.18,0,0,1,.61,1.69l-.57,11.9a1.87,1.87,0,0,0,3.26,1.53l9-8.26a2.13,2.13,0,0,1,1.69-.61l12.48,1.47c1.67.2,3.12-1.92,2.46-3.59L689.43,560A2.77,2.77,0,0,1,690,557.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be8122ba-2ae8-4506-8d24-ab4eec9e9c6e",
    d: "M459.16,546.7l-8,31.63c-1.34,5.27,2.86,10.19,7.15,8.36L492.51,566a4.63,4.63,0,0,1,3.49-.07l35,19.36c4.35,1.67,8.37-3.4,6.83-8.62l-8.65-29.3a7.64,7.64,0,0,1,1.72-7.47l20.63-20.22c3.53-3.46,2.26-10.36-2.16-11.74L514.1,497a5.89,5.89,0,0,1-3.54-3.4l-13-30c-2.13-4.91-7.94-4.8-9.88.19L475.53,495a5.9,5.9,0,0,1-3.42,3.54L439.64,510c-4.36,1.55-5.36,8.49-1.7,11.82l19.22,17.44A7.63,7.63,0,0,1,459.16,546.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be8122ba-2ae8-4506-8d24-ab4eec9e9c6e",
    d: "M570.34,71.17,561,82.31c-1.55,1.86-.82,4.64,1.26,4.74L580,85.36a2,2,0,0,1,1.41.65l10.3,14.52c1.43,1.51,4,.25,4.41-2.14L598.31,85a3.37,3.37,0,0,1,2.13-2.66l12.18-4.13c2.08-.71,2.91-3.73,1.4-5.13L602,61.82a2.63,2.63,0,0,1-.77-2l.57-14.53a2.29,2.29,0,0,0-4-1.83L586.89,53.59a2.61,2.61,0,0,1-2,.76l-15.25-1.66c-2.05-.22-3.79,2.38-3,4.42L571,67.82A3.41,3.41,0,0,1,570.34,71.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be8122ba-2ae8-4506-8d24-ab4eec9e9c6e",
    d: "M164.71,133.64,160.86,146c-.64,2.07.92,4.11,2.66,3.47l14-7.5a1.81,1.81,0,0,1,1.39.05l13.5,8.42c1.69.75,3.39-1.18,2.89-3.29l-2.82-11.82a3,3,0,0,1,.83-2.92l8.62-7.61c1.48-1.3,1.12-4.07-.61-4.71L187.58,115a2.35,2.35,0,0,1-1.34-1.43l-4.54-12.17a2,2,0,0,0-3.93-.13l-5.48,12.15a2.33,2.33,0,0,1-1.43,1.33l-13.14,3.89c-1.76.53-2.3,3.26-.92,4.66l7.27,7.33A3,3,0,0,1,164.71,133.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be8122ba-2ae8-4506-8d24-ab4eec9e9c6e",
    d: "M94.12,344.57l25.39-5.38c4.84-1,7.48-7.52,4.49-11.06l-22.23-26.3a5.92,5.92,0,0,1-1.16-4.78L105.86,264c.84-5.29-4.12-8.31-8.43-5.15L71.09,278.12a5.91,5.91,0,0,1-4.78,1.15l-36-8.29c-4.5-1-9.08,4.28-7.78,9l7.62,27.87a7.62,7.62,0,0,1-2.29,7.3L5.63,336.14c-4,3.73-3.06,10.14,1.54,10.89l40,.94a4.61,4.61,0,0,1,3,1.82l19.12,35.12c2.78,3.75,8.89,1.62,10.39-3.61l9-31.36A7.6,7.6,0,0,1,94.12,344.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ebd4af80-3442-4a52-9c85-a60a43b07864",
    d: "M740.19,211.8h0a15.49,15.49,0,0,1,8.18,10.56c-1.65,51.64,19,75.39,29.91,84.27a29.72,29.72,0,0,0,6.07,4.2l.43.23h0a29.55,29.55,0,0,0,42.5-22.48h0s5.48-27.26-3.82-50.77a29,29,0,0,1-2.1-10.55c0-3.62-.79-6.68,3.1-11.44h0a109.31,109.31,0,1,0-84.28-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    d: "M636.7,243.12c-3.9,1-6.59,5.27-6.18,10.15.45,5.33,4.45,9.34,8.93,9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 707.73,
    cy: 250.5,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(220.38 821.58) rotate(-69.01)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    points: "640.81 261.98 628.92 180.82 697.59 190.56 714.4 305.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    points: "714.4 305.3 645.73 295.56 640.81 261.98"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 707.73,
    cy: 130.67,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 787.11,
    cy: 125.27,
    r: 8.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M709.66,250.78s60.39,41.11,100.62-20.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M816.76,385.65s-16.23-25.8-3.17-75.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M783.7,383.05s-16.61-24.75-3.55-74.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M748.08,221.19s-12-11.17-44.1-2.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 209.24,
    cy: 372.12,
    r: 8.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 331.31,
    cy: 354.28,
    r: 8.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 441.46,
    cy: 411.23,
    rx: 8.15,
    ry: 9.69,
    transform: "translate(-73.25 725.97) rotate(-74.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M440.25,417.31s-19.34,89-117.86,80.92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bf9a05b8-9708-487a-9c8a-361612284e30",
    cx: 107.02,
    cy: 477.16,
    rx: 9.69,
    ry: 8.15,
    transform: "translate(-336.58 271.36) rotate(-52.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M108.79,478s63.84,66.45,120,18.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ebd4af80-3442-4a52-9c85-a60a43b07864",
    d: "M317.61,512.38a39,39,0,0,1,22.64-33.8c.49-.22,1-.43,1.5-.64h0a139.6,139.6,0,0,0,91.87-109.87c12.1-75.59-39.75-147.4-115.29-159.82a139.68,139.68,0,0,0-92,259.05h0c12.62,8.69,11.1,17,8.69,21.6a105.49,105.49,0,0,0-7.19,16.55c-19.94,61.43-4.06,89.57-4.06,89.57s18.07,37.91,38.84,41.61c21.48,3.83,43.05,1.14,55.06-20a60.77,60.77,0,0,0,6.45-41.6C321,559,316.64,532.46,317.61,512.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M256.4,634.53s-25.26,47.55,6.77,110.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M297.44,634.66s-.87,60.1,66.56,93.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M497.35,354.63l-63.84-31.05a138.28,138.28,0,0,1,.11,44.49,140,140,0,0,1-13.9,42.28l67.13-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd1c892d-4ad6-49eb-8a54-832c027f8fdc",
    d: "M662.13,184.75c-44.74-39.95-112.9-31.47-144.21,11.57C485,241.6,504.55,308.16,537.2,327.41c29.38,17.32,57.5-10.67,87.14,8.48,26.16,16.91,43.29,63.93,21.59,96.4-22.42,33.56-74.84,34.38-104.87,11.56-17.56-13.34-9-39-28.53-52.43a40.44,40.44,0,0,0-21.18-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.7c07036a4b5f32c96a0cbb2b2d5ab3f4.svg";
export { ForwardRef as ReactComponent };